// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { Button } from "@cirrus/ui-kit/src/components/molecules/button/index.js"

import { DialogContent, DialogTitle, Paper, styled } from "@mui/material"
import React, { Fragment } from "react"
import { setLocalStorageValues, TableLocalStorageKey } from "../../helpers"
import { getDefaultTableOrder } from "../../helpers/getDefaultTableOrder"
import { useTableContext } from "../../provider"
import { ColumnSwitch } from "./ColumnSwitch"
import { useColumnMenuStyles } from "./styles"

const StyledPaper = styled(Paper)({
  overflowY: "scroll",
  maxHeight: window.screen.height < 1051
    ? "calc(100vh/2)"
    : "inherit",
  boxShadow: "0 5px 5px -3px rgba(0, 0, 0, .2)," +
    " 0 8px 10px 1px rgba(0, 0, 0, .14)," +
    " 0 3px 14px 2px rgba(0, 0, 0, .12)"
})

export const ColumnMenu = () => {
  const { contentContainer, dialogTitle, paper, resetCustomization, switchContainer } = useColumnMenuStyles()


  const ctx = useTableContext()
  const { tableId, columns } = ctx.props
  const { customizableColumns } = ctx.columns.state

  const resetCustomizationHandler = () => {

    const defaultVisibility = customizableColumns.reduce((accum, item) => {
      return {
        ...accum,
        [item.field]: !item.hidden && (item.default ?? false),
      }
    }, {})

    const defaultOrder = getDefaultTableOrder(columns)

    ctx.columns.api.setVisible(defaultVisibility)
    ctx.columns.api.setOrder(defaultOrder)

    setLocalStorageValues(tableId, TableLocalStorageKey.visibleColumns, null)
    setLocalStorageValues(tableId, TableLocalStorageKey.order, defaultOrder)
  }

  const getContent = () => (
    <div className={switchContainer}>
      {customizableColumns.filter(column => !column.hideInColumnMenu).map(({ field, headerName, isLocked }, index) => (
        <ColumnSwitch
          key={index}
          {...{
            field,
            headerName,
            index,
            isLocked,
            tableId,
          }}
        />
      ))}
    </div>
  )

  return (
    <StyledPaper classes={{ root: paper }} >
      <DialogTitle classes={{ root: dialogTitle }}>
        {i18n("General:CustomizeTable")}
      </DialogTitle>

      <DialogContent classes={{ root: contentContainer }}>
        <Fragment>
          <div style={{ paddingBottom: "20px" }}>{i18n("General:CustomizeDialogContent")}</div>
          {getContent()}
          <Button
            label={i18n("General:ResetSettings")}
            title={i18n("General:ResetSettings")}
            variant={"outlined"}
            className={resetCustomization}
            onClick={resetCustomizationHandler}
          />
        </Fragment>
      </DialogContent>
    </StyledPaper>
  )
}
